<template>
  <div class="modal-card is-desktop is-centered">
    <table width="100%">
      <header class="modal-card-head">
        <p class="modal-card-title">Delete Confirmation</p>
        <button type="button" class="delete" @click="$parent.close()" />
      </header>
      <section class="modal-card-body">
        <b-field
          label="Please enter the Submission Id to delete items. Enter All to delete all the items across the Submissions."
        >
          <b-input
            type="text"
            placeholder="Submission Id"
            v-model="deleteAllItemsSubmissionById"
            required
          >
          </b-input>
        </b-field>
        <b-field label="A comment is required inorder to delete an Item.">
          <b-input
            type="text"
            placeholder="Comments"
            v-model="comments"
            required
          >
          </b-input>
        </b-field>
      </section>
      <footer class="modal-card-foot">
        <button class="button" type="button" @click="$parent.close()">
          Close
        </button>
        <button
          class="button is-primary"
          type="button"
          @click="
            deleteAllItemsSubmissionById && comments ? getSubmissionId() : ''
          "
        >
          OK
        </button>
      </footer>
    </table>
  </div>
</template>

<script>
export default {
  name: "DeleteAllModal",
  data() {
    return {
      deleteAllItemsSubmissionById: "",
      comments: ""
    };
  },
  methods: {
    getSubmissionId() {
      var newItemSubmissionComponentScope = this;
      newItemSubmissionComponentScope.$http
        .put(
          `${process.env.VUE_APP_API_BASE_DOMAIN}erroredMFItems/deleteSubmissionById?nbrNewItemCrKey=${this.deleteAllItemsSubmissionById}&comments=${this.comments}`
        )
        // eslint-disable-next-line no-unused-vars
        .then(function(response) {
          newItemSubmissionComponentScope.isLoading = false;
          newItemSubmissionComponentScope.$buefy.dialog.alert({
            message: `Item(s) deleted Successfully.`,
            confirmText: "OK",
            type: "is-success",
            onConfirm: () => (
              newItemSubmissionComponentScope.$emit("reloadEMF", true),
              newItemSubmissionComponentScope.$emit("goToHomePage", true)
            )
          });
        });
      newItemSubmissionComponentScope.deleteAllFlag = false;
    }
  }
};
</script>

<style scoped></style>
